import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Subtabs.module.scss';

const Subtabs = ({ counters, subtabs, currentSubtab, setSubTab, pendingCounters }) => {
  const { t } = useTranslation();

  const [currentSubtabs, setCurrentSubtabs] = useState([]);

  const clickAction = (value) => {
    if (value.isActive) return;
    value.setActive();
    setCurrentSubtabs((prev) =>
      prev.map((tab) => (tab.value === value.value ? { ...tab, isActive: true } : { ...tab, isActive: false }))
    );
  };

  useEffect(() => {
    if (!pendingCounters)
      setCurrentSubtabs(
        Object.values(subtabs).reduce(
          (result, subtab) =>
            counters[subtab] || subtab === 'saved'
              ? [
                  ...result,
                  {
                    label: t(`common.general.${subtab}`),
                    value: subtab,
                    isActive: currentSubtab === subtab,
                    setActive: () => setSubTab((prev) => ({ ...prev, page: 1, subTab: subtab }))
                  }
                ]
              : result,
          []
        )
      );
  }, [pendingCounters]);

  return (
    <section className={classes.subtabsContainer}>
      {!pendingCounters &&
        currentSubtabs.map((subtab) => (
          <div
            role="presentation"
            key={subtab.label}
            className={`${classes.tab} ${subtab.isActive ? classes.active : ''}`}
            onClick={() => clickAction(subtab)}
          >
            {subtab.label}
          </div>
        ))}
    </section>
  );
};

export default Subtabs;
